import FilePieChart from "./FilePieChart";

export {FilePieChart}
export default FilePieChart